import React from 'react';
import { ListsPrintView, Phase } from '@teetsh/app/src/types/sequences';
import HtmlViewer from '@teetsh/app/src/components/HtmlViewer';
import { getDurationInHoursAndMinutes } from '@teetsh/app/src/utils/time/getDurationInHoursAndMinutes';
import { CustomFieldsList } from '@teetsh/app/src/containers/Sequences/Print/FicheDePrep/CustomFieldsList';
import 'twin.macro';
import { Color } from '@teetsh/app/src/types/colors';
import { ClockIcon } from '@heroicons/react/24/outline';
import { extractFirstStyleAttribute } from '@teetsh/app/src/utils/htmlUtils';
import { css } from '@emotion/react';

interface Props {
  phase: Phase;
  index?: number;
  color?: Color;
  fieldsToDisplay?: string[];
  listsPrintView?: ListsPrintView;
}

export function PhaseComponent(props: Props) {
  const {
    phase: { flow, title, dureeInMinute },
    index,
    color = 'yellow-200',
    fieldsToDisplay,
    listsPrintView,
  } = props;
  const customFields = (props.phase?.customFields || []).filter(
    cf => fieldsToDisplay === undefined || fieldsToDisplay.includes(cf.id),
  );

  const shouldDisplayCustomFields =
    customFields.length > 0 &&
    customFields.some(cf => cf.value || cf.items?.length > 0);

  // phase titles can be styled using froala.
  // best effort : we extract the first style attribute and apply it to the number
  const extractedStyle = index ? extractFirstStyleAttribute(title) : '';

  return (
    <>
      <div tw="flex mb-4 items-start">
        <h3 tw="grow ml-1 mr-2">
          <div tw="flex items-baseline">
            <span tw="whitespace-nowrap flex-shrink-0">
              {index && (
                <span
                  css={css`
                    ${extractedStyle}
                  `}
                >
                  {`${index}. `}
                </span>
              )}
            </span>
            <div tw="min-w-0 inline-flex">
              <HtmlViewer onChange={() => {}} text={title} print />
            </div>
          </div>
        </h3>
        {dureeInMinute && (
          <div tw="pt-1 flex items-center gap-x-1">
            <ClockIcon tw="h-3.5 w-3.5" />
            {getDurationInHoursAndMinutes(dureeInMinute)}
          </div>
        )}
      </div>
      {shouldDisplayCustomFields && (
        <div
          tw="mb-4 grid gap-x-4 gap-y-2"
          style={{ gridTemplateColumns: '1fr 4fr' }}
        >
          <CustomFieldsList
            items={customFields}
            listsPrintView={listsPrintView}
            view="cards"
            color={color}
          />
        </div>
      )}
      <HtmlViewer text={flow} onChange={() => {}} print />
    </>
  );
}
